import {Component, createRef, RefObject} from "react";
import {ContentModelName} from "../../contenful/types";
import {connect} from "react-redux";
import {AppState} from "../../RootReducer";

import {logout, showLogin} from "../../user/UserActions";
import {Dispatch} from "redux";
import {toggleShowUserNavigation} from "../../navigation/NavigationActions";
import {fetchContent} from "../../contenful/ContentfulActions";
import "./styles/Menu.scss";
import {LoginStatus} from "../../http/Types";
import {NavLink, RouteComponentProps, withRouter} from "react-router-dom";
import {t} from "../../i18n";
import {
    AccountBalance,
    AppContext,
    AppMode,
    CurrencyDefinition,
    KycStatus,
    Settings,
    TransferLimit,
    UserInfo
} from "../../http/protocol";
import {fetchSettings} from "../../settings/SettingsActions";
import {Modal} from "react-bootstrap";

import "../../layout/styles/MenuButton.scss";
import {isMobile} from "react-device-detect";
import {showCashier} from "../../payments/DepositActions";
import {CashierSection} from "../../payments/PaymentsReducer";
import {getUnreadMessagesCount, getUnseenBonusOffers, getUnseenRewards} from "../../selectors/messages-selector";
import {BrandA} from "../buttons/buttons";
import { getAppContext, getIsGlifeContext, getIsMayaMiniAppContext } from "../../selectors/settings-selectors";

interface State {
    logoutClick: boolean;
    loggingOut: boolean;
    withdrawClicked: boolean;
    showMatiModal: boolean;
    showInsufficientFundsModal?: boolean;
    insufficientFundsMessage?: string;

}

type AllProps = PropsFromState & PropsFromDispatch & RouteComponentProps;

export const MenuCloseButton = () => (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
         width="20px" height="20px" viewBox="-36.5 91.5 648.5 684.99" >
        <polygon className="icon-fill" points="356.28,433.98 599.55,167.05 611.11,154.38 599,142.22 562.78,105.85 549.45,92.47 536.72,106.43
                                            287.76,379.61 38.77,106.43 26.04,92.46 12.71,105.86 -23.51,142.26 -35.61,154.41 -24.06,167.08 219.22,434.01 -24.05,700.94
                                            -35.61,713.61 -23.5,725.76 12.72,762.13 26.05,775.52 38.78,761.56 287.74,488.38 536.73,761.56 549.46,775.53 562.79,762.13
                                            599.01,725.73 611.11,713.58 599.56,700.91 "/>

    </svg>
);
export class Menu extends Component<AllProps, State> {
    private container : RefObject<HTMLDivElement>= createRef<HTMLDivElement>();

    constructor(props: AllProps) {
        super(props);

        this.state = {
            logoutClick: false,
            loggingOut: false,
            withdrawClicked: false,
            showMatiModal: false,
            showInsufficientFundsModal: false,
            insufficientFundsMessage: ""
        }
    }

    componentDidMount(): void {
        document.addEventListener('mousedown',this.handleClick.bind(this), false);
        setTimeout(()=>{
            //@ts-ignore
            document.getSelection().removeAllRanges();
        },1);
        this.props.toggleShowUserNavigation && this.props.toggleShowUserNavigation(true);

        if(this.props.settings == undefined) {
            this.props.fetchSettings();
        }

    }
    handleClick(e : MouseEvent) {
        if(!this.container || !this.container.current || !e.target) {
            return;
        }
        if(this.container.current.contains(e.target as any)) {
            return;
        }
        if(this.props.open) {
            this.props.close && this.props.close();
        }
    }

    componentWillUnmount(): void {
        document.removeEventListener('mousedown', this.handleClick, false);
        this.props.toggleShowUserNavigation && this.props.toggleShowUserNavigation(false);
    }

    handleGoBack = () => {
        this.props.toggleShowUserNavigation && this.props.toggleShowUserNavigation(false);
        this.props.history.goBack();
    };

    handleLogOut = () => {
        this.setState({loggingOut: true});
    };

    handleHideModal = () => {
        this.setState({showMatiModal: false, showInsufficientFundsModal: false})
    };

    handleWithdrawAndMati = () => {
        if(this.props.settings && this.props.settings.kycOnWithdrawRequired && this.props.user && !this.props.user.kycVerified) {
            if(this.props.user && (this.props.metamapStatus === KycStatus.NOT_STARTED)) {
                this.setState({withdrawClicked: !this.state.withdrawClicked});
            } else {
                this.setState({showMatiModal: true})
            }
        } else {
            this.props.showWithdraw && this.props.showWithdraw();
        }
    };

    insufficientFundsModal() {
        return(
            <Modal size="sm"
                   aria-labelledby="contained-modal-title-vcenter"
                   centered
                   show={this.state.showInsufficientFundsModal}
                   onHide={() => this.setState({showInsufficientFundsModal:false})}>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <p>{t("store.bundles.withdrawAmountNotValidText") +' '+ this.state.insufficientFundsMessage}</p>
                </Modal.Body>
            </Modal>
        )
    }


    render() {
        let kycStatus = this.props.user && this.props.user.kycStatus; // need to check the metamapStatus here as well
        let kycOnWithdrawRequired = this.props.settings && this.props.settings.kycOnWithdrawRequired;
        let loggingOut = this.state.loggingOut;

        let kycRequired: boolean = (kycOnWithdrawRequired ? true : false) && ( kycStatus == KycStatus.NOT_STARTED  || kycStatus == undefined);
        let close = () => this.props.close && this.props.close();
        return (
            <div style={{display : this.props.open ? "" : "none"}}>

                    <div  className={"menuContainer"} ref={this.container}>
                            <div className={"menu"}>
                                <div className={"menu-title"}>
                                    {this.props.user?.attributes?.["screenName"] ?? ""}
                                </div>
                                <div className={"menu-close"} onClick={()=> this.props.close && this.props.close()}>
                                    <MenuCloseButton />
                                </div>
                                <nav className={`menuButtonWrapper ${isMobile ? 'mobile' : ''}`}>
                                    <NavLink to={"/account/profile"} className={"menu-button profile-button"}  onClick={()=>close()}>
                                        <span className={"icon"}>
                                            <i className={"material-icons"}>account_circle</i>
                                        </span>
                                        <span className={"title"}>{t("menu.profile")}</span>
                                    </NavLink>
                                    <NavLink to={"/account/balances"} className={"menu-button balances-button"}  onClick={()=>close()}>
                                        <span className={"icon"}>
                                            <i className={"material-icons"}>account_balance_wallet</i>
                                        </span>
                                        <span className={"title"}>{t("menu.balances")}</span>
                                    </NavLink>
                                    <NavLink to={"/account/transactions/wallet"} className={"menu-button transactions-button"} onClick={()=>close()}>
                                        <span className={"icon"}>
                                            <i className={"material-icons"}>format_list_bulleted</i>
                                        </span>
                                        <span className={"title"}>{t("menu.transactions")}</span>
                                    </NavLink>

                                    {this.props.settings && this.props.settings.showUserLevel &&
                                    <NavLink to={"/account/vip-level"} className={"menu-button vipLevel-button"} onClick={()=>close()}>
                                        <span className={"icon"}>
                                            <i className={"material-icons"}>military_tech</i>
                                        </span>
                                        <span className={"title"}>{t("menu.vip-level")}</span>
                                    </NavLink>}

                                    {this.props.settings && this.props.settings.bonusEnabled &&
                                    <NavLink to={"/account/bonus"} className={"menu-button bonus-button"} onClick={()=>close()}>
                                        <span className={"icon"}>
                                            <i className={"material-icons"}>card_giftcard</i>
                                        </span>
                                        <span className={"title"}>
                                            {t("menu.bonus")}
                                            {(this.props.unseenBonusOffers ?? 0 ) > 0 && <span className={"unread-notifications"}>{this.props.unseenBonusOffers}</span>}
                                        </span>
                                    </NavLink>
                                    }
                                    <NavLink to={"/account/rewards"} className={"menu-button bonus-button"} onClick={()=>close()}>
                                        <span className={"icon"}>
                                            <i className={"material-icons"}>local_activity</i>
                                        </span>
                                        <span className={"title"}>
                                            {t("menu.rewards")}
                                            {(this.props.unseenRewards ?? 0 ) > 0 && <span className={"unread-notifications"}>{this.props.unseenRewards}</span>}
                                        </span>
                                    </NavLink>
                                    <NavLink to={"/account/messages"} className={"menu-button messages-button"} onClick={()=>close()}>
                                        <span className={"icon"}>
                                            <i className={"material-icons"}>mail</i>
                                        </span>
                                        <span className={"title"}>
                                            {t("menu.messages")}
                                            {(this.props.unreadMessages ?? 0 ) > 0 && <span className={"unread-notifications"}>{this.props.unreadMessages}</span>}
                                        </span>

                                    </NavLink>
                                    <a ph-autocapture="true" ph-autocapture-event="withdraw" onClick={()=> {this.handleWithdrawAndMati(); close();}} className={"menu-button withdraw-button"} >
                                        <span className={"icon"}>
                                            <i className={"material-icons"}>credit_card</i>
                                        </span>
                                        <span className={"title"}>{t("menu.withdraw")}</span>
                                    </a>


                                    {!this.props.isMayaMiniApp && this.props.appContext !== AppContext.GLIFE && (
                                            <BrandA className={"menu-button logout-button"} loading={loggingOut}  onClick={() => { this.props.logout?.(); this.handleLogOut(); }}>
                                                <span className={"icon"}>
                                                    <i className={"material-icons"}>logout</i>
                                                </span>
                                                <span className={"title"}>{t("menu.logout")}</span>
                                            </BrandA>
                                    )}
                                    <div className={"deposit-button-container"}>
                                        <a ph-autocapture="true" ph-autocapture-event="deposit" className={"btn btn-cta small"} onClick={()=>{
                                            this.props.showDeposit && this.props.showDeposit();
                                            close();
                                        }}>
                                            {t("global.depositButton")}
                                        </a>
                                    </div>
                                </nav>


                                {/* <MatiComponent clicked={this.state.withdrawClicked} kycRequired={kycRequired} matiEnabled={this.props.settings?.matiEnabled ?? false}/>
                                <MatiModal show={this.state.showMatiModal} hide={this.handleHideModal} /> */}

                                {this.state.showInsufficientFundsModal && (
                                    this.insufficientFundsModal()
                                )}
                            </div>
                        </div>

            </div>

        )
    }

}



interface PropsFromState {
    showUserNavigation?: boolean;
    loggedIn?: boolean;
    user?: UserInfo;
    settings?: Settings;
    transferLimits?: TransferLimit[];
    currency?: string;
    amount?:string;
    balances?:AccountBalance[];
    currencies?: CurrencyDefinition[];
    metamapStatus: KycStatus;
    appMode?: AppMode;
    close? : () => void;
    open?: boolean;
    unreadMessages? : number;
    unseenBonusOffers? : number;
    unseenRewards? : number;
    isMayaMiniApp?: boolean;
    appContext?: AppContext
}

interface PropsFromDispatch {
    toggleShowUserNavigation? : (show : boolean) => void;
    showLogin? : ()=> void;
    logout? : ()=>void;
    showDeposit? : () => void;
    showWithdraw? : () => void;
    fetchContent: typeof fetchContent;
    fetchSettings: typeof fetchSettings;
}

const mapDispatchToProps = (dispatch : Dispatch) => (
    {
        toggleShowUserNavigation : (show: boolean)=>dispatch(toggleShowUserNavigation(show)),
        showLogin : ()=> dispatch(showLogin(true)),
        logout : () => dispatch(logout() as any),
        fetchContent: (contentModelName: ContentModelName, locale?: string) => dispatch(fetchContent(contentModelName, locale) as any),
        fetchSettings: () => dispatch(fetchSettings() as any),
        showDeposit : () => dispatch(showCashier(true, CashierSection.DEPOSIT)),
        showWithdraw : () => dispatch(showCashier(true, CashierSection.WITHDRAW))
    }
)

const mapStateToProps = (state : AppState) => {

    return {
        global: state.contentful.global,
        showUserNavigation : state.navigation.showUserNavigation,
        loggedIn : LoginStatus.LOGGED_IN == state.user.status,
        user: state.user.user,
        settings: state.settings.settings,
        transferLimits: state.settings.settings?.transferLimits,
        balances : state.user?.balances,
        currency :state.payments.withdraw.activeCurrency,
        amount : state.payments.withdraw.amount,
        currencies: state.user.user?.currencies,
        metamapStatus: state.user.metamapStatus,
        appMode : state.user.appMode,
        unreadMessages : getUnreadMessagesCount(state),
        unseenBonusOffers : getUnseenBonusOffers(state),
        unseenRewards : getUnseenRewards(state),
        isMayaMiniApp: getIsMayaMiniAppContext(state),
        appContext: getAppContext(state)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Menu)) as any;